import React, { Fragment, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import Toasts from '@components/toasts/Toasts';
import CookiePopup from '@components/tracking/CookiePopup';
import Build from '@js/pages/build/Build';
import Dashboard from '@js/pages/dashboards/Dashboard';
import CreateProject from '@js/pages/dashboards/CreateProject';
import SelectTemplate from '@js/pages/dashboards/SelectTemplate';
import Output from '@js/pages/build/Output';
import Error404 from '@js/pages/errors/Error404';
import Loader from '@components/shared/Loader';
import { usePassportContext, LoginRouter } from '@tti/passport';
import { connect } from 'react-redux';
import { fetchTranslations, fetchCmsOneTrustConfiguration } from '@redux/actioncreators/app';
import ReactPdfPreview from './ReactPdf';

const AppRouter = ({ app, fetchTranslationsInternal, fetchCmsOneTrustConfigurationInternal }) => {
  const { passportContext } = usePassportContext();

  useEffect(() => {
    fetchTranslationsInternal({ cultureCode: app.uiCultureCode });
    // Fetch the CMS OneTrust configuration
    fetchCmsOneTrustConfigurationInternal({ cultureCode: app.uiCultureCode });
  }, [app.uiCultureCode]);

  // If we have a bearer token, we need to check if the user is still being validated
  if (passportContext.bearerToken && passportContext.bearerToken.length > 0) {
    // Check if the user is still being validated
    if (passportContext.isValidating) {
      return (
        <div className="full-loader-container">
          <Loader />
        </div>
      );
    }
  }

  if (app.cmsOneTrustConfigurationLoading) {
    return (
      <div className="full-loader-container">
        <Loader />
      </div>
    );
  }

  const renderContent = () => {
    // If we don't have a bearer token, we need to show the login router
    if (!passportContext.bearerToken || passportContext.bearerToken.length === 0) {
      return (
        <>
          <LoginRouter successPath={'/'} />
        </>
      );
    }

    return (
      <Fragment>
        <Toasts />
        <Switch>
          {/* Dashboard Routes */}
          <Route exact path="/" component={Dashboard} />
          <Route exact path="/dashboard/" component={Dashboard} />
          <Route exact path="/dashboard/bays/" component={CreateProject} />
          <Route exact path="/dashboard/templates/:projectTypeGuid/" component={SelectTemplate} />

          {/* Build Routes */}
          <Route exact path="/build/:projectGuid?" component={Build} />
          <Route exact path="/build/output/:projectGuid?" component={Output} />
          <Route exact path="/build/react-pdf/:projectGuid" component={ReactPdfPreview} />

          {/* 404 Page */}
          <Route exact path="/404/" component={Error404} />

          {/* Catch all */}
          <Route component={Error404} />
        </Switch>
      </Fragment>
    );
  };

  return (
    <>
      <CookiePopup />
      {renderContent()}
    </>
  );
};

const mapStateToProps = state => ({
  app: state.app.present.app,
});

const mapDispatchToProps = dispatch => ({
  // Culture codes are never used in fetchTranslations and fetchCmsOneTrustConfiguration
  fetchTranslationsInternal: ({ cultureCode }) => dispatch(fetchTranslations({ cultureCode })),
  // Not sure how dispatch is used here
  fetchCmsOneTrustConfigurationInternal: ({ cultureCode }) => dispatch(fetchCmsOneTrustConfiguration({ cultureCode })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
